<template>
  <section class="max-w-600 mx-auto min-vh-100 min-height-mobile booking-doctor">
    <div class="bg-white text-center py-3 position-relative z-1 cursor-pointer" @click="backToHome()">
      <font-awesome-icon
        v-if="stepComponent !== 'initial' && stepComponent !== 'input-otp' && stepComponent !== 'register-otp'"
        icon="chevron-left"
        size="lg"
        class="position-absolute left-3 top-4 cursor-pointer"
        @click="backToHome()"
      />
      <img src="https://ydbucketstorage.s3.ap-southeast-1.amazonaws.com/img/v3/main/brand.png" height="35px">
      <h4 v-if="stepComponent === 'initial' && profileDoctor" class="text-left text-grey-netral font-rubik-medium mb-0 ml-3 mt-2">
        Pilih Jadwal
      </h4>
    </div>
    <template v-if="profileDoctor">
      <!--    Profile Doctor-->
      <div
        v-if="profileDoctor && (stepComponent === 'initial' || stepComponent === 'confirmation')"
        ref="profileDoctor"
        class="profile-doctor my-2"
        :style="stepComponent === 'initial' || (stepComponent === 'confirmation' && showAppointment) ? `transform: translateY(${scrollTop*-1}px)` : ''"
      >
        <el-image
          style="width: 120px; height: 120px"
          class="mr-2"
          :src="`${profileDoctor.AvatarUrl}?w=250`"
          fit="cover"
          :preview-src-list="[`${profileDoctor.AvatarUrl}?w=500`]"
        />
        <div class="d-flex flex-column flex-grow-1 py-2">
          <p class="name-doctor">
            {{ profileDoctor.Fullname }}
          </p>
          <span class="specialist-doctor">{{ profileDoctor.DoctorTypeLang ? profileDoctor.DoctorTypeLang.ID.replace(/[_-]/g, " ") : profileDoctor.DoctorType.replace(/[_-]/g, " ") }}</span>
          <div>
            <div v-if="profileDoctor" class="rating-doctor mr-2">
              <client-only>
                <img src="@/assets/icon/icon-star.svg" alt="icon-star">
              </client-only>
              <span>{{ profileDoctor.Rating || 5 }}</span>
              <span v-if="doctorData" class="font-weight-normal">({{ doctorData.TotalConsult || 0 }})</span>
            </div>
            <div v-if="doctorData" class="rating-doctor mr-2">
              <client-only>
                <img src="@/assets/icon/icon-case-minimalistic.svg" alt="icon-briefcase">
              </client-only>
              <span>{{ doctorData.Experience || 0 }} Thn</span>
            </div>
            <span v-b-modal.modal-profile class="text-profile font-rubik-medium float-sm-right mr-3 cursor-pointer">
              Profil
              <client-only>
                <font-awesome-icon icon="chevron-right" />
              </client-only>
            </span>
          </div>
        </div>
      </div>
      <component :is="stepComponent" ref="component" />
    </template>
    <template v-else>
      <div class="mt-2 text-center bg-white px-3" style="min-height: calc(100vh - 75px)">
        <img src="@/assets/img/gagal.png" class="mt-5">
        <h2 class="mt-5">
          Halaman tidak ditemukan
        </h2>
        <p class="my-5 font-20px">
          Mohon periksa kembali url yang anda masukkan
        </p>
        <b-button size="lg" block variant="primary-3" class="border-r25px" @click="downloadApp">
          DOWNLOAD YESDOK
        </b-button>
      </div>
    </template>
    <template v-if="appointmentList && appointmentList.length > 0">
      <div v-if="widthScreen < 468 && isMobile" class="px-sm-5 px-3" :class="(stepComponent === 'confirmation' || stepComponent === 'list-payments') && checkCountdown ? 'py-3 text-center button-modal-continue' : 'pb-3 button-continue d-flex'">
        <template v-if="stepComponent === 'initial' || checkCountdown">
          <b-button
            v-if="txtTimePicker"
            v-b-modal.modal-share-social
            pill
            variant="primary-3"
            class="mr-3 px-3"
            :class="(stepComponent === 'confirmation' || stepComponent === 'list-payments') ? 'd-none' : ''"
          >
            <font-awesome-icon
              icon="share-alt"
              size="lg"
            />
          </b-button>
          <b-button
            v-if="stepComponent !== 'confirmation' && stepComponent !== 'list-payments'"
            :disabled="!txtTimePicker"
            size="lg"
            variant="success-2"
            class="border-r25px font-rubik-medium btn-block"
            @click="$refs.component.handleScheduleNext()"
          >
            Lanjutkan <font-awesome-icon icon="chevron-right" class="mr-n2" /> <font-awesome-icon icon="chevron-right" />
          </b-button>
        </template>
        <template v-else>
          <b-button
            v-b-modal.modal-share-social
            size="lg"
            block
            variant="primary-3"
            class="border-r25px"
          >
            <font-awesome-icon
              icon="share-alt"
              size="lg"
            /> BAGIKAN JADWAL
          </b-button>
        </template>
      </div>
      <template v-if="(stepComponent === 'confirmation' || stepComponent === 'list-payments') && checkCountdown">
        <div class="btn-popup">
          <div class="next-schedule mx-3">
            <b-button
              size="lg"
              variant="success-2"
              class="border-r25px font-rubik-medium text-uppercase w-50 mx-auto"
              @click="continueSchedule()"
            >
              Lanjutkan
            </b-button>
          </div>
          <div class="py-2 btn-search-doctor px-3">
            <b-button
              block
              size="lg"
              class="border-r25px font-rubik-medium btn-primary-3 my-0 px-4 py-2 text-uppercase d-flex justify-content-between align-items-center"
              @click="goToListDoctor()"
            >
              Pilih dokter yang tersedia <img width="20px" src="@/assets/img/arrow-right-white.png">
            </b-button>
          </div>
        </div>
      </template>
    </template>
    <b-modal
      id="modal-profile"
      modal-class="modal-bottom backdrop-primary"
      centered
      hide-header
      hide-footer
    >
      <div v-if="profileDoctor" class="py-3">
        <div class="d-flex align-items-center mb-4">
          <el-image
            style="width: 100px; height: 100px"
            class="mr-3 rounded-circle border-w2 border-primary-2"
            :src="`${profileDoctor.AvatarUrl}?w=200`"
            fit="cover"
            :preview-src-list="[`${profileDoctor.AvatarUrl}?w=500`]"
          />
          <div class="d-flex flex-column text-premier-blue flex-1">
            <p class="border-b font-20px mb-2 pb-2">
              {{ profileDoctor.Fullname }}
            </p>
            <span class="font-rubik-medium">{{ profileDoctor.DoctorTypeLang ? profileDoctor.DoctorTypeLang.ID.replace(/[_-]/g, " ") : profileDoctor.DoctorType.replace(/[_-]/g, " ") }}</span>
          </div>
        </div>
        <div v-if="doctorData">
          <div class="border border-r6px px-3 py-2 text-premier-blue mb-3">
            <span>Total Konsultasi</span>
            <p class="font-20px mb-0 font-rubik-medium">
              {{ doctorData.TotalConsult || 0 }}
            </p>
          </div>
          <div class="border border-r6px px-3 py-2 text-premier-blue mb-3">
            <span>Bahasa</span>
            <p class="font-20px mb-0 font-rubik-medium">
              {{ doctorData.Language === 'ID' ? 'Bahasa Indonesia' : 'English' || '-' }}
            </p>
          </div>
          <div class="border border-r6px px-3 py-2 text-premier-blue mb-3">
            <span>Nomor STR</span>
            <p class="font-20px mb-0 font-rubik-medium">
              {{ doctorData.NoReg || 0 }}
            </p>
          </div>
          <div class="border border-r6px px-3 py-2 text-premier-blue">
            <span>Universitas</span>
            <p class="font-20px mb-0 font-rubik-medium">
              {{ doctorData.University || '-' }}
            </p>
          </div>
        </div>
        <div class="text-center">
          <b-button
            variant="primary-3"
            class="mt-5 border-r25px px-5"
            @click="closeModalProfile"
          >
            Tutup
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-share-social" centered hide-footer title="BAGIKAN JADWAL DOKTER">
      <div class="row">
        <div class="col-4 social-icon" @click="handleLink('tw')">
          <img
            src="@/assets/img/twitter-icon.png"
            class="handle-icon"
            alt=""
          >
          <div><span>Twitter</span></div>
        </div>
        <div class="col-4 social-icon" @click="handleLink('fb')">
          <img
            src="@/assets/img/facebook-icon.png"
            class="handle-icon"
            alt=""
          >
          <div><span>Facebook</span></div>
        </div>
        <div class="col-4 social-icon pt-2" @click="handleLink('mail')">
          <img
            src="@/assets/img/mail-icon.png"
            class="handle-icon"
            alt=""
          >
          <div><span>Email</span></div>
        </div>

        <div class="col-4 social-icon" @click="handleLink('in')">
          <img
            src="@/assets/img/linkedin-icon.png"
            class="handle-icon"
            alt=""
          >
          <div><span>LinkedIn</span></div>
        </div>
        <div class="col-4 social-icon">
          <img
            src="@/assets/img/whatsapp-icon.png"
            class="handle-icon"
            alt=""
            @click="handleLink('wa')"
          >
          <div><span @click="handleLink('wa')">Whatsapp</span></div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import Initial from '@/components/appointment-component/Initial'
import Confirmation from '@/components/appointment-component/Confirmation'
import ListPayments from '@/components/appointment-component/ListPayments'
import Login from '@/components/appointment-component/Login'
import InputOtp from '@/components/appointment-component/InputOtp'
import Register from '@/components/appointment-component/Register'
import RegisterOtp from '@/components/appointment-component/RegisterOtp'
import PaymentSuccess from '@/components/appointment-component/PaymentSuccess'
import { isAndroid, isIOS } from 'mobile-device-detect'
export default {
  name: 'BookingDoctor',
  components: {
    Initial,
    Confirmation,
    ListPayments,
    Login,
    InputOtp,
    Register,
    RegisterOtp,
    PaymentSuccess
  },
  async asyncData ({ route, store, redirect }) {
    const id = route.params.doctorNickName
    try {
      const doctorProfile = await store.dispatch('doctor/nearest', { did: id })
      return { doctorProfile }
    } catch (error) {
      redirect(`/${route.params.doctorNickName}`)
    }
  },
  data: () => ({
    title: 'Booking Konsultasi Video dengan Dokter Spesialis',
    description: 'Beneran Ketemu dengan Dokter Pilihanmu di YesDok',
    timestampNow: null,
    txtDatePicker: null,
    txtTimePicker: null,
    lblConsultPrice: '',
    timestampStart: null,
    timestampEnd: null,
    lblDateSelected: null,
    lblTimeSelected: null,
    payMethod: null,
    addPaymentFailed: false,
    scrollTop: 0,
    showAppointment: false,
    profileDoctorHeight: 0,
    appointmentList: [],
    widthScreen: 0,
    heightScreen: 0,
    isMobile: false
  }),
  head () {
    return {
      title: this.doctorProfile ? this.doctorProfile.Doctor.Fullname : this.title,
      description: this.description,
      meta: [
        { hid: 'og:title', property: 'og:title', content: this.doctorProfile ? this.doctorProfile.Doctor.Fullname : this.title },
        { hid: 'og:description', property: 'og:description', content: this.description },
        { hid: 'og:image', property: 'og:image', content: this.doctorProfile ? `${this.doctorProfile.Doctor.AvatarUrl}?w=200` : process.env.BASE_SPECIALIST_URL + 'img/thumbnail-konsultasi.jpeg' },
        { hid: 'og:url', property: 'og:url', content: process.env.BASE_SPECIALIST_URL + this.$route.params.doctorNickName },
        { hid: 'og:site_name', property: 'og:site_name', content: process.env.PAGE_TITLE },
        { hid: 'apple-mobile-web-app-title', property: 'apple-mobile-web-app-title', content: process.env.PAGE_TITLE }
      ]
    }
  },
  computed: {
    checkCountdown () {
      return this.$store.state.doctor.countdownOff
    },
    appointmentBook () {
      return this.$store.state.doctor.appointmentBook
    },
    profileDoctor () {
      return this.doctorProfile ? this.doctorProfile.Doctor : null
    },
    doctorData () {
      return this.$store.state.doctor.doctorData ? this.$store.state.doctor.doctorData.Doctor : null
    },
    did () {
      return this.$route.params.doctorNickName
    },
    stepComponent: {
      get () {
        return this.$store.state.doctor.stepComponent
      },
      set (val) {
        return this.$store.commit('doctor/SET_STEP', val)
      }
    }
  },
  watch: {
    txtTimePicker (next, prev) {
      if (next !== prev) {
        const appointment = this.$store.state.doctor.doctorData.Appointments.find(o => o.PublicID === this.txtTimePicker)
        this.$store.commit('doctor/SET_BOOKING_APPOINTMENT', appointment)
        localStorage.setItem('public_id', this.txtTimePicker)
        localStorage.setItem('booking', JSON.stringify(this.$store.state.doctor.booking.selectedAppointment))
        if (this.$store.state.patient.auth.userData && this.$store.state.doctor.stepComponent === 'confirmation') {
          const componentConfirmation = this.$refs.component
          if (componentConfirmation) {
            componentConfirmation.getAppointmentBook()
          }
        }
      }
    }
  },
  mounted () {
    localStorage.removeItem('booking')
    const elementBody = document.body
    elementBody.classList.add('bg-booking')
    this.checkLocalstorage()
    this.setToken()
    this.setPartnerParams()
    this.$nextTick(() => {
      if (this.$refs.profileDoctor) {
        this.profileDoctorHeight = this.$refs.profileDoctor.clientHeight
      }
      this.$nuxt.$on('appointmentList', (apppointments) => {
        this.appointmentList = apppointments
      })
      this.widthScreen = window.innerWidth
      this.heightScreen = window.innerHeight
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      window.addEventListener('resize', this.onResize)
    })
    this.$nuxt.$on('hiddenProfile', (top) => {
      this.scrollingTop(top, this.profileDoctorHeight + 10)
    })
    this.checkMobile()
    this.stepComponent = 'initial'
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setToken () {
      const token = this.$route.query.token
      if (token) {
        localStorage.setItem('token', token)
      }
    },
    setPartnerParams () {
      const partner = this.$route.query.partner
      if (partner) {
        sessionStorage.setItem('partner', partner)
      }
    },
    continueSchedule () {
      this.$store.commit('doctor/SET_COUNTDOWN_OFF', false)
      if (this.$store.state.doctor.stepComponent === 'list-payments') {
        this.$store.commit('doctor/SET_STEP', 'confirmation')
        this.$store.commit('doctor/SET_PAYMENT', null)
        localStorage.setItem('step', 'confirmation')
      }
    },
    goToListDoctor () {
      return window.open(`${process.env.BASE_YD_URL}/${this.$store.state.patient.auth.userData.Language === 'ID' ? 'id' : 'en'}/doctor/list`, '_self')
    },
    onResize () {
      this.widthScreen = window.innerWidth
      this.heightScreen = window.innerHeight
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      if (this.$refs.profileDoctor) {
        this.profileDoctorHeight = this.$refs.profileDoctor.clientHeight
      }
    },
    scrollingTop (top, max) {
      if (top <= max) {
        this.scrollTop = top
      }
      if (top > max) {
        const minus = max - this.scrollTop
        this.scrollTop += minus
      }
      this.$store.commit('doctor/SET_SCROLL_TOP', this.scrollTop)
    },
    checkLocalstorage () {
      if (localStorage.getItem('step')) {
        if (localStorage.getItem('step') === 'confirmation') {
          this.stepComponent = 'initial'
          localStorage.setItem('step', 'initial')
          return
        }
        this.stepComponent = localStorage.getItem('step')
      }
    },
    backToHome () {
      this.$router.push(this.$route.fullPath)
      this.$store.commit('doctor/SET_PAYMENT', null)
      this.$store.commit('doctor/SET_PAYMENT_INDEX', null)
      this.$store.commit('doctor/SET_APPOINTMENT_BOOK', null)
      this.$store.commit('doctor/SET_STEP', 'initial')
      localStorage.setItem('step', 'initial')
    },
    closeModalProfile () {
      this.$bvModal.hide('modal-profile')
    },
    downloadApp () {
      if (process.client) {
        if (isIOS) {
          return window.open('http://ydok.co/ios', '_blank')
        }
        if (isAndroid) {
          return window.open('http://ydok.co/android', '_blank')
        }
        return window.open('http://ydok.co/dw', '_blank')
      }
    },
    handleLink (location) {
      const self = this
      const path = process.env.BASE_SPECIALIST_URL
      const letter = this.doctorData.Fullname ? this.doctorData.Fullname.split('') : ''
      const lastIndex = letter.length - 1

      if (letter[lastIndex] === ' ') {
        letter.splice(lastIndex, 1)
      } else if (letter[0] === ' ') {
        letter.splice(0, 1)
      }
      const joinedLetter = letter.join('')
      this.shareText = `${joinedLetter} konsultasi online sekarang`
      if (location === 'wa') {
        window.open(`https://api.whatsapp.com/send?text=*${joinedLetter}*%0A${self.profileDoctor.DoctorTypeLang.ID}%0A%0AKonsultasi Gampang!%0ALihat jadwal konsultasi online:%0A${path}${self.$route.params.doctorNickName}`, '_blank')
      } else if (location === 'mail') {
        window.open(`mailto:?Subject=${self.shareText}&Body=${joinedLetter}%0AKonsultasi Gampang!%0A%0ALihat jadwal konsultasi online:%0A${path}${self.$route.params.doctorNickName}`, '_blank')
      } else if (location === 'fb') {
        window.open(`http://www.facebook.com/sharer.php?u=${path}${self.$route.params.doctorNickName}`, '_blank')
      } else if (location === 'in') {
        window.open(`http://www.linkedin.com/sharing/share-offsite/?url=${path}${self.$route.params.doctorNickName}`, '_blank')
      } else if (location === 'tw') {
        window.open(`https://twitter.com/share?url=${path}${self.$route.params.doctorNickName}&text=${joinedLetter}%0AKonsultasi Gampang!%0A%0DLihat jadwal konsultasi online:%0A`, '_blank')
      }
    },
    checkMobile () {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        ) { check = true }
      })(navigator.userAgent || navigator.vendor || window.opera)
      this.isMobile = check
    }
  }
}
</script>

<style lang="scss">
  // $primary: #024668;
  $grey-netral: #404040;
  .z-1 {
    z-index: 1;
  }
  .btn-popup {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 600px;
    max-width: 600px;
    text-align: center;
    background: #ffffff;
    @media screen and (max-width: 480px) {
      width: -webkit-fill-available;
    }
    .next-schedule {
      padding: 10px 0px;
      background: #F7F7F7;
    }
  }
  .min-height-mobile {
    height: calc(var(--vh, 1vh) * 100);
    min-height: -webkit-fill-available;
  }
  .font-20px {
    font-size: 20px;
  }
  .flex-1 {
    flex: 1 1 auto;
  }
  .left-3 {
    left: 1rem;
  }
  .top-4 {
    top: 1.5rem;
  }
  .pb-4\.5 {
    padding-bottom: 2rem !important;
  }
  .text-premier-blue {
    color: #024668;
  }
  .border-b {
    border-bottom: 1px solid #E6E6E6;
  }
  .max-w-600 {
    max-width: 600px;
  }
  .bg-booking {
    background: #F3F2EF !important;
  }
  .profile-doctor {
    display: flex;
    color: $grey-netral;
    background-color: #fff;
    position: relative;
    z-index: 0;
    .name-doctor {
      font-size: 18px;
      margin-bottom: 5px;
      font-weight: 500;
    }
    .specialist-doctor {
      margin-bottom: 10px;
      font-weight: 600;
    }
    .rating-doctor {
      display: inline-block;
      font-weight: 600;
      background-color: #F3F2EF;
      border-radius: 3px;
      padding: 1px 7px;
      max-width: fit-content;
    }
    .text-profile {
      white-space: nowrap;
    }
  }

  @media screen and (max-width: 468px) {
    .button-continue {
      width: 100%;
      position: fixed;
      bottom: 0;
      z-index: 10;
      padding-bottom: 10px;
      padding-top: 10px;
      background-color: #fff;
    }
    .button-modal-continue {
      left: 15px;
      z-index: 10;
      right: 15px;
      bottom: 70px;
      width: inherit;
      position: fixed;
      background: #F7F7F7;
    }
  }
</style>
